import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

/**
 * Takes in an array of feature flags, and returns an object with their values in boolean.
 * @param featureFlagCodes The codes for the feature flags.
 * @returns An object with feature flags values in boolean.
 */
const useFeatureFlags = <FlagType = boolean | undefined>(
  featureFlagCodes: string[]
): Record<string, FlagType> => {
  const flags = useFlags();

  const featureFlagsMap = useMemo(() => {
    const newRecord = {};

    featureFlagCodes.forEach((featureFlagCode) => {
      newRecord[featureFlagCode] = flags?.[featureFlagCode] as FlagType;
    });

    return newRecord;
  }, [featureFlagCodes, flags]);

  return featureFlagsMap;
};

export default useFeatureFlags;
